export class Api {
  id?: number
  appId?: number
  appName?: string
  url?: string
  description?: string
}

export class ApiAuthority {
  id?: number
  apiId?: number
  url?: string
  encrypted?: number | boolean
  ticket?: string
  publicKey?: string
  description?: string
}